// AUTO-GENERATED (scripts/gen_prefetch_map.py) — do not edit by hand.
// Route path -> lazy chunk importer, used for hover prefetch. Mirrors the
// lazy() imports in App.js; webpack dedupes to the same chunk.
export const ROUTE_IMPORTERS = {
  "/admin": () => import("./pages/Admin"),
  "/admin/agency-settings": () => import("./pages/AdminAgencySettings"),
  "/admin/announcements": () => import("./pages/admin/Announcements"),
  "/admin/audit-log": () => import("./pages/admin/AuditLog"),
  "/admin/avi/audit-log": () => import("./pages/admin/AviAuditLogs"),
  "/admin/avi/corpus": () => import("./pages/admin/AviCorpusAdmin"),
  "/admin/backups": () => import("./pages/AdminBackups"),
  "/admin/bgc-rulesets": () => import("./pages/admin/BgcRulesets"),
  "/admin/compliance-rulesets": () => import("./pages/admin/ComplianceRulesets"),
  "/admin/contact-registry": () => import("./pages/admin/ContactRegistry"),
  "/admin/fax-auto-route": () => import("./pages/admin/FaxAutoRoute"),
  "/admin/health": () => import("./pages/admin/SystemHealth"),
  "/admin/integration-health": () => import("./pages/admin/IntegrationHealth"),
  "/admin/phi-watchdog": () => import("./pages/admin/PhiWatchdog"),
  "/admin/qa-sweep": () => import("./pages/QASweep"),
  "/admin/security-settings": () => import("./pages/healthcare/SecuritySettings"),
  "/admin/setup": () => import("./pages/admin/Setup"),
  "/admin/training": () => import("./pages/AdminTraining"),
  "/admin/training-downloads": () => import("./pages/TrainingDownloads"),
  "/agents": () => import("./pages/AgentDashboard"),
  "/analytics": () => import("./pages/Analytics"),
  "/analytics/live-calls": () => import("./pages/LiveCallsAnalytics"),
  "/audit-log": () => import("./pages/AuditLogPage"),
  "/calendar": () => import("./pages/Calendar"),
  "/callbacks": () => import("./pages/Callbacks"),
  "/chat": () => import("./pages/ChatPage"),
  "/comms": () => import("./pages/UnifiedInbox"),
  "/comms/unassigned": () => import("./pages/UnassignedComms"),
  "/documents": () => import("./pages/Documents"),
  "/forgot-password": () => import("./pages/ForgotPassword"),
  "/healthcare": () => import("./pages/healthcare/HealthcareDashboard"),
  "/healthcare/activity-feed": () => import("./pages/healthcare/ActivityFeed"),
  "/healthcare/adjustment-rules": () => import("./pages/healthcare/AdjustmentRules"),
  "/healthcare/admin": () => import("./pages/healthcare/AdminSetup"),
  "/healthcare/admin/client-assignment": () => import("./pages/healthcare/ClientAssignment"),
  "/healthcare/admin/compliance": () => import("./pages/healthcare/ComplianceOverview"),
  "/healthcare/admin/critical-alerts": () => import("./pages/healthcare/CriticalAlertsAdmin"),
  "/healthcare/admin/disclosures": () => import("./pages/healthcare/DisclosureAccounting"),
  "/healthcare/admin/duplicate-scan": () => import("./pages/healthcare/admin/DuplicateScan"),
  "/healthcare/admin/entities": () => import("./pages/healthcare/EntityManagement"),
  "/healthcare/admin/evv-clearinghouse": () => import("./pages/healthcare/EVVClearinghouseSettings"),
  "/healthcare/admin/icd10": () => import("./pages/healthcare/admin/Icd10Codes"),
  "/healthcare/admin/initial-setup": () => import("./pages/healthcare/OnboardingWizard"),
  "/healthcare/admin/integrations": () => import("./pages/healthcare/admin/Integrations"),
  "/healthcare/admin/location-dashboard": () => import("./pages/healthcare/LocationDashboard"),
  "/healthcare/admin/locations": () => import("./pages/healthcare/LocationsManagement"),
  "/healthcare/admin/mcos": () => import("./pages/healthcare/admin/McoDirectory"),
  "/healthcare/admin/payers": () => import("./pages/healthcare/PayerSetup"),
  "/healthcare/admin/redactions": () => import("./pages/healthcare/RedactionsQueue"),
  "/healthcare/admin/retention": () => import("./pages/healthcare/RetentionAdmin"),
  "/healthcare/admin/service-codes": () => import("./pages/healthcare/ServiceCodes"),
  "/healthcare/admin/settings": () => import("./pages/healthcare/GeneralSettings"),
  "/healthcare/admin/staff-assignment": () => import("./pages/healthcare/StaffAssignment"),
  "/healthcare/admin/user-roles": () => import("./pages/healthcare/UserRoles"),
  "/healthcare/ai-narratives": () => import("./pages/healthcare/AINarratives"),
  "/healthcare/alerts": () => import("./pages/healthcare/AlertCenter"),
  "/healthcare/analytics": () => import("./pages/healthcare/Analytics"),
  "/healthcare/ar-aging": () => import("./pages/healthcare/ARAging"),
  "/healthcare/audit-log": () => import("./pages/healthcare/AuditLog"),
  "/healthcare/audit-readiness": () => import("./pages/healthcare/AuditReadiness"),
  "/healthcare/auth": () => import("./pages/healthcare/AuthorizationsOrders"),
  "/healthcare/auth/485-tracker": () => import("./pages/healthcare/CMS485Tracker"),
  "/healthcare/auth/medical-records": () => import("./pages/healthcare/AuthorizationsOrders"),
  "/healthcare/auth/physician-orders": () => import("./pages/healthcare/AuthorizationsOrders"),
  "/healthcare/authorization-management": () => import("./pages/healthcare/AuthorizationManagement"),
  "/healthcare/availity": () => import("./pages/healthcare/AvailityHub"),
  "/healthcare/batch-operations": () => import("./pages/healthcare/BatchOperations"),
  "/healthcare/billing": () => import("./pages/healthcare/BillingDashboard"),
  "/healthcare/billing-readiness": () => import("./pages/healthcare/BillingReadiness"),
  "/healthcare/care-plan-wizard": () => import("./pages/healthcare/CarePlanWizard"),
  "/healthcare/care-plans": () => import("./pages/healthcare/CarePlans"),
  "/healthcare/care-plans/build": () => import("./pages/healthcare/CarePlanDetail"),
  "/healthcare/caregivers": () => import("./pages/healthcare/CaregiverList"),
  "/healthcare/caregivers/new": () => import("./pages/healthcare/AddEmployee"),
  "/healthcare/census": () => import("./pages/healthcare/CensusListing"),
  "/healthcare/chase-queue": () => import("./pages/healthcare/ChaseQueue"),
  "/healthcare/claim-validator": () => import("./pages/healthcare/ClaimValidator"),
  "/healthcare/claims": () => import("./pages/healthcare/Claims"),
  "/healthcare/client-surveys": () => import("./pages/healthcare/ClientSurveys"),
  "/healthcare/clients": () => import("./pages/healthcare/PatientList"),
  "/healthcare/clients/agreements": () => import("./pages/healthcare/ClientAgreements"),
  "/healthcare/clients/clinical": () => import("./pages/healthcare/clients/ClinicalActions"),
  "/healthcare/clients/ehr-completeness": () => import("./pages/healthcare/clients/EhrCompleteness"),
  "/healthcare/clients/hospitalizations": () => import("./pages/healthcare/clients/Hospitalizations"),
  "/healthcare/clients/new": () => import("./pages/healthcare/AddPatient"),
  "/healthcare/clients/supervisory-visits-due": () => import("./pages/healthcare/clients/SupervisoryVisitsDue"),
  "/healthcare/clients/surveys": () => import("./pages/healthcare/clients/ClientSurveys"),
  "/healthcare/clinical": () => import("./pages/healthcare/ClinicalHub"),
  "/healthcare/clinical-compliance": () => import("./pages/healthcare/ClinicalCompliance"),
  "/healthcare/clinical/cms485": () => import("./pages/healthcare/ClinicalHub"),
  "/healthcare/clinical/pcst": () => import("./pages/healthcare/ClinicalHub"),
  "/healthcare/company/new": () => import("./pages/healthcare/CompanyWizard"),
  "/healthcare/compliance-qa": () => import("./pages/healthcare/ComplianceQA"),
  "/healthcare/daily-digest": () => import("./pages/healthcare/DailyDigest"),
  "/healthcare/dashboard-customizer": () => import("./pages/healthcare/DashboardCustomizer"),
  "/healthcare/denial-management": () => import("./pages/healthcare/DenialManagement"),
  "/healthcare/dev-tools": () => import("./pages/healthcare/DevTools"),
  "/healthcare/disposition-queue": () => import("./pages/healthcare/DispositionQueue"),
  "/healthcare/documents": () => import("./pages/healthcare/EHRRecords"),
  "/healthcare/e-signatures": () => import("./pages/healthcare/ESignatures"),
  "/healthcare/eligibility": () => import("./pages/healthcare/EligibilityVerification"),
  "/healthcare/employee-badge": () => import("./pages/healthcare/EmployeeBadge"),
  "/healthcare/evv-alerts": () => import("./pages/healthcare/EvvAlerts"),
  "/healthcare/evv-portal-workers": () => import("./pages/healthcare/PortalWorkers"),
  "/healthcare/evv-workflow": () => import("./pages/healthcare/EVVWorkflow"),
  "/healthcare/evv/geofence-exceptions": () => import("./pages/healthcare/GeofenceExceptions"),
  "/healthcare/executive": () => import("./pages/healthcare/ExecutiveDashboard"),
  "/healthcare/fax/unmatched": () => import("./pages/healthcare/UnmatchedFaxes"),
  "/healthcare/field-visits": () => import("./pages/healthcare/FieldVisits"),
  "/healthcare/field-visits/new": () => import("./pages/healthcare/FieldVisitWizard"),
  "/healthcare/form-templates": () => import("./pages/healthcare/FormTemplates"),
  "/healthcare/forms": () => import("./pages/healthcare/Filing"),
  "/healthcare/forms-legacy": () => import("./pages/healthcare/DocumentCenter"),
  "/healthcare/ghost-user-report": () => import("./pages/healthcare/GhostUserReport"),
  "/healthcare/google-calendar": () => import("./pages/healthcare/GoogleCalendar"),
  "/healthcare/google-drive": () => import("./pages/healthcare/GoogleDrive"),
  "/healthcare/grievances": () => import("./pages/healthcare/Grievances"),
  "/healthcare/guide": () => import("./pages/healthcare/UserGuide"),
  "/healthcare/hosp-safeguards": () => import("./pages/healthcare/HospSafeguards"),
  "/healthcare/incidents": () => import("./pages/healthcare/IncidentReporting"),
  "/healthcare/invoices": () => import("./pages/healthcare/Invoices"),
  "/healthcare/live-monitor": () => import("./pages/healthcare/LiveMonitor"),
  "/healthcare/mco-travel-log": () => import("./pages/healthcare/MCOTravelLog"),
  "/healthcare/mco-travel-log/coverage": () => import("./pages/healthcare/ItineraryCoverage"),
  "/healthcare/month-end": () => import("./pages/healthcare/MonthEndClose"),
  "/healthcare/notifications": () => import("./pages/healthcare/NotificationEngine"),
  "/healthcare/onboarding/pa-packets": () => import("./pages/healthcare/onboarding/PaPacketsPage"),
  "/healthcare/pa-renewal": () => import("./pages/healthcare/PARenewal"),
  "/healthcare/pa-tracker": () => import("./pages/healthcare/PATracker"),
  "/healthcare/patients": () => import("./pages/healthcare/PatientList"),
  "/healthcare/patients/new": () => import("./pages/healthcare/AddPatient"),
  "/healthcare/pay-periods": () => import("./pages/healthcare/PayPeriods"),
  "/healthcare/pay-rates": () => import("./pages/healthcare/PayRates"),
  "/healthcare/payments": () => import("./pages/healthcare/PaymentPosting"),
  "/healthcare/payroll": () => import("./pages/healthcare/PayrollSummaryReport"),
  "/healthcare/payroll-dashboard": () => import("./pages/healthcare/PayrollSummaryReport"),
  "/healthcare/payroll-recon": () => import("./pages/healthcare/PayrollReconciliation"),
  "/healthcare/pcw-portal": () => import("./pages/healthcare/PCWPortal"),
  "/healthcare/pcw-timesheets": () => import("./pages/healthcare/PCWTimesheets"),
  "/healthcare/pcw-timesheets/catch-up": () => import("./pages/healthcare/TimesheetCatchUp"),
  "/healthcare/physician-portal": () => import("./pages/healthcare/PhysicianPortal"),
  "/healthcare/portal": () => import("./pages/healthcare/ClientPortal"),
  "/healthcare/pre-pcst-analyses/build": () => import("./pages/healthcare/PrePcstAnalysis"),
  "/healthcare/predictive": () => import("./pages/healthcare/PredictiveAnalytics"),
  "/healthcare/providers": () => import("./pages/healthcare/ProviderDirectory"),
  "/healthcare/reconciliation-reports": () => import("./pages/healthcare/ReconciliationReports"),
  "/healthcare/relationship-log": () => import("./pages/healthcare/RelationshipLog"),
  "/healthcare/roster": () => import("./pages/healthcare/CaregiverRoster"),
  "/healthcare/rules": () => import("./pages/healthcare/RulesEngine"),
  "/healthcare/sandata": () => import("./pages/healthcare/SandataExport"),
  "/healthcare/sandata-aggregator": () => import("./pages/healthcare/SandataAggregator"),
  "/healthcare/sandata-export": () => import("./pages/healthcare/SandataVisitExport"),
  "/healthcare/sandata-reconcile": () => import("./pages/healthcare/SandataReconcile"),
  "/healthcare/sandata-validation": () => import("./pages/healthcare/SandataValidation"),
  "/healthcare/schedule": () => import("./pages/healthcare/ScheduleCalendar"),
  "/healthcare/scheduling/coverage": () => import("./pages/healthcare/ShiftCoverage"),
  "/healthcare/security": () => import("./pages/healthcare/SecuritySettings"),
  "/healthcare/security-settings": () => import("./pages/healthcare/SecuritySettings"),
  "/healthcare/service-care-plans": () => import("./pages/healthcare/ServiceCarePlans"),
  "/healthcare/service-plans": () => import("./pages/healthcare/ServiceCarePlans"),
  "/healthcare/settings/pa-alert-recipients": () => import("./pages/healthcare/PAAlertRecipients"),
  "/healthcare/staff-credentials": () => import("./pages/healthcare/StaffCredentialDashboard"),
  "/healthcare/staff-eligibility": () => import("./pages/healthcare/StaffEligibility"),
  "/healthcare/supervisory-visits": () => import("./pages/healthcare/SupervisoryVisits"),
  "/healthcare/supervisory-visits/new": () => import("./pages/healthcare/SupervisoryVisitForm"),
  "/healthcare/supportive-care": () => import("./pages/healthcare/SupportiveCare"),
  "/healthcare/supportive-care/iadl-reference": () => import("./pages/healthcare/IadlTaskReference"),
  "/healthcare/surveyor-packet": () => import("./pages/healthcare/SurveyorPacket"),
  "/healthcare/tasks": () => import("./pages/healthcare/TaskQueue"),
  "/healthcare/timesheets": () => import("./pages/healthcare/TimesheetList"),
  "/healthcare/travel-log": () => import("./pages/healthcare/TravelLog"),
  "/healthcare/visits": () => import("./pages/healthcare/Visits"),
  "/healthcare/voice-line-diagnostics": () => import("./pages/healthcare/VoiceLineDiagnostics"),
  "/help": () => import("./pages/healthcare/UserGuide"),
  "/history": () => import("./pages/CallHistory"),
  "/knowledge-base": () => import("./pages/KnowledgeBase"),
  "/knowledge-base/user-manual": () => import("./pages/UserManual"),
  "/learn": () => import("./learn/LearningLanding"),
  "/learn/admin": () => import("./learn/LearningAdmin"),
  "/learn/catalog": () => import("./learn/LearningCatalog"),
  "/learn/certificates": () => import("./learn/LearningCertificates"),
  "/learn/my": () => import("./learn/LearningMy"),
  "/my-work": () => import("./pages/projects/MyWork"),
  "/notepad": () => import("./pages/Notepad"),
  "/pcw": () => import("./pages/healthcare/PCWPortal"),
  "/pcw/clock-in": () => import("./pages/pcw/PcwClockIn"),
  "/permissions": () => import("./pages/PermissionsPage"),
  "/phone": () => import("./pages/CommsEntry"),
  "/projects": () => import("./pages/projects/ProjectsPortfolio"),
  "/projects/new": () => import("./pages/projects/NewProject"),
  "/register": () => import("./pages/Register"),
  "/reset-password": () => import("./pages/ResetPassword"),
  "/settings": () => import("./pages/Settings"),
  "/tasks": () => import("./pages/Tasks"),
  "/time-tracking": () => import("./pages/TimeTracking"),
  "/tools": () => import("./pages/Tools"),
  "/tools/bgc-cases": () => import("./pages/tools/BgcCases"),
  "/tools/bgc-statute-check": () => import("./pages/tools/BgcStatuteChecker"),
  "/tools/contact-registry": () => import("./pages/admin/ContactRegistry"),
  "/tools/evv-dashboard": () => import("./pages/healthcare/EvvOpsDashboard"),
  "/tools/evv-exceptions": () => import("./pages/healthcare/EvvExceptionQueue"),
  "/tools/evv-interview": () => import("./pages/healthcare/EvvWorkerInterview"),
  "/tools/evv-missed": () => import("./pages/healthcare/EvvMissedBoard"),
  "/tools/evv-ops": () => import("./pages/healthcare/EvvOpsDashboard"),
  "/tools/phi-watchdog": () => import("./pages/admin/PhiWatchdog"),
  "/tools/prior-authorization": () => import("./pages/healthcare/PriorAuthTool"),
  "/tools/qa-sweep": () => import("./pages/QASweep"),
  "/tools/sandata-aggregator": () => import("./pages/healthcare/SandataAggregator"),
  "/tools/screening": () => import("./pages/healthcare/ScreeningTool"),
  "/tools/training-downloads": () => import("./pages/TrainingDownloads"),
  "/tools/word-processor": () => import("./pages/tools/WordProcessor"),
  "/training": () => import("./pages/TrainingLibrary"),
  "/training/downloads": () => import("./pages/TrainingDownloads"),
  "/video": () => import("./pages/Video"),
  "/work": () => import("./pages/work/WorkHub"),
};
